import WhatsappOutlined from "@mui/icons-material/WhatsApp";
import {
  Alert,
  Grid,
  MenuItem,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { useState } from "react";
import { FormSubmitButton } from "./Elements";

const Form = ({ onFormSubmit, mentor, formRef, fontFamily = "Outfit" }) => {
  const [email, setEmail] = useState("");
  const [year, setYear] = useState("2023");
  const [showAlert, setShowAlert] = useState(false);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleYearChange = (e) => {
    setYear(e.target.value);
  };
  const handleAlertClose = (e) => {
    setShowAlert(false);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (mentor === null) {
      setShowAlert(true);
      return;
    }

    await onFormSubmit({
      email,
      university: ["Tel Aviv University"],
      year,
      mentor: mentor.name,
      mentorId: mentor._id,
      source: "bu.edu",
    });
  };

  return (
    <Box sx={{ boxShadow: "none" }}>
      <Snackbar
        open={showAlert}
        autoHideDuration={3000}
        onClose={handleAlertClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleAlertClose} severity="error">
          Please select a mentor
        </Alert>
      </Snackbar>
      <form onSubmit={handleFormSubmit}>
        <Grid
          container
          paddingLeft={1}
          paddingRight={1}
          sx={{ borderTop: "1px solid #cacaca" }}
        >
          {mentor?.bcl ? (
            <Grid item xs={10} marginTop={1}>
              <Typography
                variant="h5"
                fontSize="0.8rem"
                ml="1rem"
                fontFamily={fontFamily}
              >
                {mentor.name.split(" ")[0]} will only be answering BCL related
                questions.
              </Typography>
            </Grid>
          ) : (
            <></>
          )}
          <Grid item xs={12}>
            <TextField
              autoFocus
              id="input-email"
              label="Enter your email"
              type="email"
              variant="filled"
              onChange={handleEmailChange}
              required
              sx={{
                backgroundColor: "#FFFFFF",
                fontFamily: fontFamily,
                "& .MuiFilledInput-underline:before": {
                  borderBottom: "1px solid rgba(0, 0, 0, 0.2)",
                },
              }}
              InputLabelProps={{
                id: "email-input-label",
                style: {
                  fontSize: "0.9rem",
                  fontFamily: "Outfit",
                  backgroundColor: "#FFFFFF",
                },
              }}
              InputProps={{
                style: {
                  fontSize: "0.9rem",
                  fontFamily: "Outfit",
                  backgroundColor: "#FFFFFF",
                  paddingBottom: "0px",
                },
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={7.5}>
            <TextField
              id="year"
              select
              margin="dense"
              label="When are you planning to apply?"
              variant="filled"
              sx={{
                "& .MuiFilledInput-underline:before": {
                  borderBottom: "1px solid rgba(0, 0, 0, 0.2)",
                },
                mt: 0,
              }}
              value={year}
              onChange={handleYearChange}
              required
              InputLabelProps={{
                id: "email-input-label",
                style: {
                  fontSize: "0.8rem",
                  fontFamily: "Outfit",
                  backgroundColor: "#FFFFFF",
                },
              }}
              InputProps={{
                style: {
                  fontSize: "0.9rem",
                  fontFamily: "Outfit",
                  backgroundColor: "#FFFFFF",
                },
              }}
              fullWidth
            >
              {["2023", "2024", "2025", "2026"].map((o) => (
                <MenuItem key={o} value={o} sx={{ fontSize: "0.9em" }}>
                  {o}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid
            item
            xs={4.5}
            justifyContent="center"
            display="flex"
            flexDirection="row"
            alignItems="center"
          >
            <FormSubmitButton
              type="submit"
              variant="contained"
              ref={formRef}
              fontFamily={"Outfit"}
            >
              <WhatsappOutlined
                style={{
                  fontSize: "1.4em",
                  color: "white",
                  marginRight: "0.2rem",
                }}
              />
              Start Chat!
            </FormSubmitButton>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default Form;
